import React, { useContext, useEffect } from 'react'

import { Parallax } from 'react-parallax';
import parse from 'html-react-parser';
import './hero.scss'
import Section from '../Section';
import Button from '../Button';
import Modal from '../Modal';
import { walletContext } from '../../contexts/walletContext'
import Grid from '@mui/material/Unstable_Grid2';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import { useAccount, useNetwork } from "wagmi";
import { ConnectButton } from '@rainbow-me/rainbowkit';
import { Stack, Typography } from "@mui/material";
import Slider from "react-slick";


export default function Web3Hero({ title, bgUrl, heroImageUrl, GifUrl, animatedUrl, pinksaleImage, reflectionsImage, pancakeswapImage, pancakeswapImageSecond, pinksaleFinalImage, variant, bubble, overlay, bgOpacity }) {
  // const { account } = useContext(walletContext)
  // const { address } = useAccount();

  const settings = {
    dots: true,
    fade: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 4,
    autoplay: true,
    autoplaySpeed: 2000,
    cssEase: "linear"
  };


  return (

    <Section tag='section' className={`cs-hero cs-style1 ${variant ? variant : ''}`} id="hero" >


      <Section className="cs-hero_bg">
        <img src={bgUrl} className="hero-image" alt="Hero" />

        {/* <Parallax bgImage={bgUrl} bgImageAlt="Hero" strength={120}></Parallax> */}

      </Section>

      <Section className="container">

        <Section className="cs-hero_text">

          <Section tag='h2' className="cs-hero_title cs-font_44 cs-font_36_sm cs-bold">{parse(title)}</Section>

          <Section className="cs-btn_group">
            <Button
              variant='cs-btn_filed cs-accent_btn mt-2'
              btnLink='https://pancakeswap.finance/swap?outputCurrency=0x1be3c9d5531Fa944f285256a348Ab067F277127D'
              btnText='Buy CATCH'>
            </Button>
            <Button
              variant='cs-btn_filed cs-accent_btn mt-2 '
              btnLink='https://www.dextools.io/app/en/bnb/pair-explorer/0xa7ba15c98a594d7bfb48fba8d41f9eb507d90db3'
              btnText='DEXTools'>
            </Button>

          </Section>
          <Section className="cs-btn_group">

            <Button
              variant='cs-btn_filed cs-accent_btn mt-2 '
              btnLink='pdf/Whitepaper.pdf'
              btnText='Whitepaper'>
            </Button>
            <Button
              variant='cs-btn_filed cs-accent_btn mt-2 '
              btnLink='pdf/Catchcoin-Pitchdeck.pdf'
              btnText='Pitchdeck'>
            </Button>

            <ConnectButton.Custom>
              {({
                account,
                chain,
                openAccountModal,
                openChainModal,
                openConnectModal,
                authenticationStatus,
                mounted,
              }) => {
                // Note: If your app doesn't use authentication, you
                // can remove all 'authenticationStatus' checks
                const ready = mounted && authenticationStatus !== "loading";
                const connected =
                  ready &&
                  account &&
                  chain &&
                  (!authenticationStatus || authenticationStatus === "authenticated");

                return (
                  <div
                    {...(!ready && {
                      "aria-hidden": true,
                      style: {
                        opacity: 0,
                        pointerEvents: "none",
                        userSelect: "none",
                        paddingTop: "10px",
                      },
                    })}
                  >
                    {(() => {
                      if (!connected) {
                        return (
                          ''
                        )
                      }
                      // console.log(chain.id);
                      if (chain.unsupported && chain.id !== 56 && chain.id !== 97) {
                        return (
                          <Button
                            onClick={openChainModal}
                            variant={"contained"}
                            color={"error"}
                          >
                            Wrong network
                          </Button>
                        );
                      }

                      return (
                        ''

                        // <Modal modalType='whitelist' account={account} btnText='Whitelist Now' />
                      );

                    })()}
                  </div>
                );
              }}
            </ConnectButton.Custom>

            {/* <Button 
                btnLink='/' 
                btnText='Join the Waitlist' 
                variant='cs-color1'
              /> */}
          </Section>

        </Section>
        <Section className="cs-hero_img">
          <div className="slider-container">
            <Slider {...settings}>
              <div>
                <img src={GifUrl} alt="catchcoin 3d coin" style={{ textAlign: 'center', width: '100%' }} />

                {/* <video width="320" height="240" controls autoplay>
  <source src="videos/catchcoin_3d_spin.mp4" type="video/mp4" />
  <source src="videos/catchcoin_3d_spin.mp4" type="video/ogg" />
  Your browser does not support the video tag.
</video> */}
              </div>

              <div>
                <img src={heroImageUrl} alt="catchcoin mobile app" style={{ textAlign: 'center' }} />
              </div>
              {/* <div>
                <a href="https://www.pinksale.finance/launchpad/bsc/0x15DcA20995378DEfaAdaad7A1FF49cd0141D79c1" target="_blank"><img src={pinksaleImage} alt="catchcoin Pinksale | CATCH" /></a>
              </div> */}
              <div>
                <img src={reflectionsImage} alt="generate foot traffic" />
              </div>
              <div>
                <a href="https://pancakeswap.finance/swap?outputCurrency=0x1be3c9d5531Fa944f285256a348Ab067F277127D" target="_blank"><img src={pancakeswapImage} alt="catchcoin Pancakeswap | CATCH" /></a>
              </div>

              {/* <div>
                <img src={pinksaleFinalImage} alt="Hero" />
              </div> */}

            </Slider>
          </div>




          {/* <Section className="cs-hero_img_sm">
                            <img src={animatedUrl} alt="Hero" />
                        </Section> */}

        </Section>

      </Section>

    </Section>
  )
}
